import React from 'react'
import ReactDOM from 'react-dom'
import 'github-markdown-css'
import './wing.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider, createClient } from 'urql'
import { READONLY_TOKEN_REVESE } from './config'

const READONLY_TOKEN = READONLY_TOKEN_REVESE.split('')
  .reverse()
  .join('')

const client = createClient({
  url: 'https://api.github.com/graphql',
  fetchOptions: {
    headers: {
      Authorization: `Bearer ${READONLY_TOKEN}`
    }
  }
})

ReactDOM.render(
  <Provider value={client}>
    <App />
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
